// document.addEventListener('DOMContentLoaded', function() {
//     // Restore checkbox states from localStorage and ensure only one is active
//     const checkboxes = document.querySelectorAll('.navPages-item input[type="checkbox"]');
//     let activeCheckboxId = localStorage.getItem('activeCheckbox');

//     checkboxes.forEach(checkbox => {
//         // Restore the checkbox state based on saved active checkbox
//         checkbox.checked = checkbox.id === activeCheckboxId;
//     });

//     // Set up event listeners for links in the navigation
//     const linkedItems = document.querySelectorAll('.navPages-item a');
//     linkedItems.forEach(item => {
//         item.addEventListener('click', function(event) {
//             // Prevent the default link behavior
//             event.preventDefault();

//             const allCheckboxes = document.querySelectorAll('.navPages-item input[type="checkbox"]');
//             const checkbox = this.querySelector('input[type="checkbox"]');
//             const wasChecked = checkbox.checked; // Check if the checkbox was already checked before toggling

//             // Uncheck all checkboxes
//             allCheckboxes.forEach(cb => cb.checked = false);

//             if (!wasChecked) {
//                 // If it wasn't checked before, check it now
//                 checkbox.checked = true;
//                 // Save the id of the active checkbox in localStorage
//                 localStorage.setItem('activeCheckbox', checkbox.id);
//             } else {
//                 // If it was checked, remove the active checkbox from localStorage
//                 localStorage.removeItem('activeCheckbox');
//             }

//             // Redirect based on checkbox state
//             setTimeout(() => {
//                 if (checkbox.checked) {
//                     window.location.href = this.href; // Navigate to the link's href attribute
//                 } else {
//                     window.location.href = '/default-path'; // Navigate to the default or general link
//                 }
//             }, 100);
//         });
//     });
// });
document.addEventListener('DOMContentLoaded', function() {
    const checkboxes = document.querySelectorAll('.navPages-item input[type="checkbox"]');
    const currentUrl = window.location.href; // Get the current page URL

    // Iterate over each checkbox and link
    checkboxes.forEach(checkbox => {
        let link = checkbox.closest('a'); // Find the closest parent link of the checkbox
        if (link && link.href === currentUrl) {
            checkbox.checked = true; // Check the checkbox if the link URL matches the current URL
            localStorage.setItem('lastCheckedCheckbox', checkbox.id); // Save the state
        } else {
            checkbox.checked = false; // Uncheck the checkbox if the link URL does not match
            if (localStorage.getItem('lastCheckedCheckbox') === checkbox.id) {
                localStorage.removeItem('lastCheckedCheckbox'); // Remove from localStorage if it was previously saved
            }
        }
    });

    const links = document.querySelectorAll('.navPages-item a');
    links.forEach(link => {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            const checkbox = this.querySelector('input[type="checkbox"]');
            const wasChecked = checkbox.checked;
            // Toggle the checkbox only if clicking on the same link to turn it off
            if (wasChecked && this.href === currentUrl) {
                checkbox.checked = false;
                localStorage.removeItem('lastCheckedCheckbox');
            } else {
                // Check this checkbox and uncheck all others
                checkboxes.forEach(cb => {
                    cb.checked = false;
                });
                checkbox.checked = true;
                localStorage.setItem('lastCheckedCheckbox', checkbox.id);
            }

            setTimeout(() => {
                window.location.href = this.href;
            }, 100);
        });
    });
});

